// import { Table, Pagination, Button, Popconfirm, Tag } from "antd";
// import moment from "moment";

// function DataTable(props) {
//   const columns = [
//     {
//       title: "Sl",
//       key: "index",
//       width: "20px",
//       render: (text, record, index) => index + 1,
//     },
//     {
//       title: "Description",
//       dataIndex: "description",
//       key: "description",
//     },
//     {
//       title: "Total Amount",
//       dataIndex: "total_amount",
//       key: "total_amount",
//     },
//     {
//       title: "Total Discount",
//       dataIndex: "total_discount",
//       key: "total_discount",
//     },
//     {
//       title: "Outstanding",
//       dataIndex: "outstanding",
//       key: "outstanding",
//     },
//     {
//       title: "Payment Date",
//       dataIndex: "payment_date",
//       key: "payment_date",
//       render: (payment_date) => moment(payment_date).format("DD-MM-YYYY"),
//     },
//     {
//       title: "Paid Amount",
//       dataIndex: "paid_amount",
//       key: "paid_amount",
//     },
//     {
//       title: "Payment Status",
//       dataIndex: "payment_status",
//       key: "payment_status",
//       render: (payment_status) => {
//         const tagColor = {
//           paid: "success",
//           partial: "warning",
//           pending: "error",
//         };
//         return (
//           <Tag color={tagColor[payment_status]}>
//             {payment_status?.charAt(0).toUpperCase() + payment_status?.slice(1)}
//           </Tag>
//         );
//       },
//     },
//     {
//       title: "Created At",
//       dataIndex: "created_at",
//       key: "created_at",
//       render: (created_at) => moment(created_at).format("DD-MM-YYYY"),
//     },
//     {
//       title: "Supplier Name",
//       dataIndex: "supplierDetails",
//       key: "supplierDetails",
//       render: (_, record) => record?.supplierDetails?.account_name || "",
//     },
//     {
//       title: "Action",
//       render: (item) => (
//         <>
//           <Button
//             size="small"
//             onClick={() => props.onUpdate(item)}
//             type="primary"
//           >
//             Edit
//           </Button>
//           <Popconfirm
//             title="Are you sure to delete this item?"
//             onConfirm={() => props.onDelete(item)}
//           >
//             <Button size="small">Delete</Button>
//           </Popconfirm>
//         </>
//       ),
//     },
//   ];

//   return (
//     <div style={{ minHeight: "60vh" }}>
//       <Table
//         columns={columns}
//         dataSource={props.data}
//         pagination={false}
//         size="small"
//       />
//       <br />
//       <div align="right">
//         <h6>
//           Total: {props.meta && props.meta.itemCount}{" "}
//           {(props.meta && props.meta.itemCount) === 1
//             ? "Purchase"
//             : "Purchases"}
//         </h6>
//         <Pagination
//           defaultCurrent={props.meta && props.meta.page}
//           total={props.meta && props.meta.itemCount}
//           pageSize={props.meta && props.meta.take ? props.meta.take : 0}
//           onChange={props.Onchange}
//           pageSizeOptions={[10, 20, 50]}
//         />
//       </div>
//     </div>
//   );
// }

// export default DataTable;
import { Table, Button, Popconfirm, Tag, Pagination } from "antd";
import moment from "moment";

const DataTable = ({
  data,
  meta,
  onDelete,
  onUpdate,
  Onchange,
  expandedRowKeys,
  setExpandedRowKeys,
}) => {
  const columns = [
    {
      title: "Sl",
      key: "index",
      width: "20px",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Total Amount",
      dataIndex: "total_amount",
      key: "total_amount",
      render: (text) => Number(text).toFixed(2),
    },
    {
      title: "Total Discount",
      dataIndex: "total_discount",
      key: "total_discount",
      render: (text) => Number(text).toFixed(2),
    },
    {
      title: "Outstanding",
      dataIndex: "outstanding",
      key: "outstanding",
      render: (text) => Number(text).toFixed(2),
    },
    {
      title: "Payment Date",
      dataIndex: "payment_date",
      key: "payment_date",
      render: (payment_date) => moment(payment_date).format("DD-MM-YYYY"),
    },
    {
      title: "Paid Amount",
      dataIndex: "paid_amount",
      key: "paid_amount",
      render: (text) => Number(text).toFixed(2),
    },
    {
      title: "Payment Status",
      dataIndex: "payment_status",
      key: "payment_status",
      render: (payment_status) => {
        const tagColor = {
          paid: "success",
          partial: "warning",
          pending: "error",
        };
        return (
          <Tag color={tagColor[payment_status]}>
            {payment_status?.charAt(0).toUpperCase() + payment_status?.slice(1)}
          </Tag>
        );
      },
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (created_at) => moment(created_at).format("DD-MM-YYYY"),
    },
    {
      title: "Supplier Name",
      dataIndex: "supplierDetails",
      key: "supplierDetails",
      render: (_, record) => record?.supplierDetails?.account_name || "",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <>
          <Button
            size="small"
            onClick={() => onUpdate(record)}
            type="primary"
            style={{ marginRight: 8 }}
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure to delete this item?"
            onConfirm={() => onDelete(record)}
          >
            <Button size="small" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  const detailColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "20%",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: "20%",
      render: (text) => text || "",
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      width: "15%",
      render: (text) => Number(text).toFixed(2),
    },

    {
      title: "Total",
      dataIndex: "total",
      key: "total",
      width: "15%",
      render: (text) => Number(text).toFixed(2),
    },
    {
      title: "Paid Amount",
      dataIndex: "paid_amount",
      key: "paid_amount",
      width: "15%",
      render: (text) => Number(text).toFixed(2),
    },
    {
      title: "Paid Status",
      width: "15%",
      render: (text) => {
        const totalPaid = text?.paid_amount || 0 + text?.discount || 0;
        const totalAmount = text?.total || 0;
        const outstanding = totalAmount - totalPaid;

        if (outstanding > 0) {
          return <Tag color="red">Unpaid</Tag>;
        } else if (outstanding === 0) {
          return <Tag color="green">Paid</Tag>;
        }
        return <Tag color="orange">Partial</Tag>;
      },
    },
  ];

  const expandedRowRender = (record) => (
    <Table
      columns={detailColumns}
      dataSource={record.purchaseDetails}
      pagination={false}
      rowKey="id"
      size="small"
    />
  );

  return (
    <div style={{ minHeight: "60vh" }}>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        pagination={false}
        size="small"
        expandable={{
          expandedRowRender,
          expandedRowKeys,
          onExpand: (expanded, record) =>
            setExpandedRowKeys(
              expanded
                ? [...expandedRowKeys, record.id]
                : expandedRowKeys.filter((key) => key !== record.id)
            ),
        }}
      />
      <br />
      <div style={{ textAlign: "right" }}>
        <h6>
          Total: {meta?.itemCount}{" "}
          {meta?.itemCount === 1 ? "Purchase" : "Purchases"}
        </h6>
        <Pagination
          current={Number(meta?.page)}
          total={Number(meta?.itemCount)}
          pageSize={Number(meta?.take)}
          onChange={Onchange}
          pageSizeOptions={[10, 20, 50]}
          showSizeChanger
        />
      </div>
    </div>
  );
};

export default DataTable;
